export const ADMIN_BASE_BATH = '/admin';
export const DEFAULT_COUNTRY_CODE = '+972';
export const RESPONSIVE_MOBILE_QUERY = { query: '(max-width: 767px)' };
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';
export const DATE_TIME_FORMAT_DB = 'YYYY-MM-DD HH:mm:ss';
export const UNIQUE_TAB_ID = 'uqTabId';
export const SOCKET_DEAL_ROOM_ONLINE_USERS = 'online-users-';
export const SOCKET_DEAL_ROOM_SYNC_ONLINE_USERS = 'sync-online-users';
export const SOCKET_DEAL_ROOM_CHANNEL = 'channel-';
export const SOCKET_DEAL_ROOM_MESSAGE_FOR_ADMIN = 'user-message-for-admin';
export const SOCKET_DEAL_ROOM_ATTACHMENT = 'room-attachment';
export const SOCKET_DEAL_ROOM_UNREAD = 'ds-unread';
